export default "__VITE_ASSET__CuwYdPGH__"